module.exports = __webpack_public_path__ + "img/dataFlow.5e43df58.png";